import { Pipe, PipeTransform } from '@angular/core';
import { PercentService } from '@rd/core/services/percent/percent.service';

@Pipe({
  name: 'localizePercent',
  pure: false,
})
export class LocalizePercentPipe implements PipeTransform {
  constructor(private percentService: PercentService) {}

  public transform(value: number, digitsInfo?: string): string {
    return this.percentService.formatPercent(value, digitsInfo);
  }
}
